import { Object3D } from "three";
import { Context } from "../context";
import { GameStateManager } from "../managers/game-state";
import { PoserClock } from "../util/clock";
import { Frames } from "../util/frames";
import { Actors } from "./actor/actors";
import { Ball } from "./ball/ball";
import { Bat } from "./bat";
import { LightRig } from "./lights/lights";
import { Stadium } from "./stadium/stadium";
import { Strikezone } from "./strikezone";

export class World extends Object3D {
  ball: Ball;
  bat: Bat;
  strikezone: Strikezone;

  stadium: Stadium;
  lights: LightRig;

  actors: Actors;

  constructor(context: Context) {
    super();
    // TODO: don't pass context on construction, but on update
    this.ball = new Ball(context);
    this.bat = new Bat(context);
    this.strikezone = new Strikezone(context);
    this.stadium = new Stadium(context);
    this.lights = new LightRig(context);
    this.actors = new Actors(context);

    this.add(this.ball);
    this.add(this.bat);
    this.add(this.strikezone);
    this.add(this.stadium);
    this.add(this.actors);
    this.add(this.lights);
  }

  async init() {
    await this.stadium.init();
    this.lights.init();
  }

  teardown() {
    this.stadium.teardown();
    this.lights.teardown();
  }

  update(clock: PoserClock, gameState: GameStateManager, frames?: Frames) {
    // console.log(`frames.current: ${frames?.current?.num}`)
    if (!clock.atBufferLimit() && frames && frames.current) {
      // actors
      this.actors.update(frames, clock.real);

      // Ball
      this.ball.update(frames, clock.real);

      // Bat
      this.bat.update(frames, clock.real);

      // Strike zone
      this.strikezone.update(clock);
    }

    this.stadium.update(clock);

    // TODO: put some things on a slower update loop
    // skybox
    this.lights.update(clock);
  }
}
